import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import food from '../assets/img/pizzaslice.jpg';
import logo from '../assets/img/logo.jpeg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logoWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 20,
      [theme.breakpoints.down('sm')]: {
        flexFlow: 'column nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 0,
      },
    },
    topHeadingTextWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'column nowrap',
      [theme.breakpoints.down('sm')]: {
        margin: 0,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'column nowrap',
      },
      '& p': {
        fontSize: 25,
        fontWeight: 'lighter',
        margin: '10px 0',
        color: theme.palette.common.white,
        padding: '30px 30px',
        maxWidth: 540,
        textAlign: 'center',
        lineHeight: 1.5,
        [theme.breakpoints.down('sm')]: {
          fontSize: 20,
          maxWidth: '90%',
          letterSpacing: 2,
          textAlign: 'center',
          margin: '10px 0',
        },
      },
    },
    logoText: {
      color: theme.palette.common.white,
      margin: 0,
      marginLeft: 30,
      lineHeight: 1,
      marginBottom: -20,
      fontSize: 80,
      textShadow: `2px 2px 2px ${theme.palette.common.black}`,
      fontWeight: 'lighter',
      [theme.breakpoints.down('sm')]: {
        fontSize: 32,
      },
    },
    topHeaderImage: {
      height: 125,
      borderRadius: 4000,
      [theme.breakpoints.down('sm')]: {
        marginBottom: 20,
      },
    },
    buttonRoot: {
      borderRadius: 10,
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      minWidth: 200,
      minHeight: 60,
      fontSize: 18,
      boxShadow: `3px 3px 20px ${theme.palette.common.black}`,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    topWrap: {
      display: 'flex',
      justifyContent: 'center',
      minHeight: 600,
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexFlow: 'column nowrap',
        minHeight: 800,
      },
    },
    topLeft: {
      flex: '1 1 50%',
      background: `url(${food})`,
      backgroundPosition: 'bottom left',
      backgroundSize: 'cover',
      position: 'relative',
      '&:before': {
        content: '""',
        height: '100%',
        width: 250,
        background:
          'linear-gradient(90deg, rgba(27,37,45,1) 0%, rgba(27,37,45,0) 100%)',
        position: 'absolute',
        left: 0,
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          height: 150,
          background:
            'linear-gradient(180deg, rgba(27,37,45,1) 0%, rgba(27,37,45,0) 100%)',
        },
      },
    },
    topRight: {
      flex: '1 1 50%',
      background: '#1b252d',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'column nowrap',
      [theme.breakpoints.down('sm')]: {
        flex: '0 0 100%',
        padding: '20px 10px',
      },
    },
    estText: {
      color: theme.palette.common.white,
      marginTop: -30,
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
      },
    },
    italyFlag: {
      height: 18,
      width: 30,
      marginRight: 10,
      display: 'block',
      background:
        'linear-gradient(90deg, rgba(0,174,0,1) 33%, rgba(255,255,255,1) 33%, rgba(255,255,255,1) 66%, rgba(255,0,0,1) 66%, rgba(255,0,0,1) 100%);',
      [theme.breakpoints.down('sm')]: {
        height: 18,
      },
    },
    topMenu: {
      width: '100%',
      height: 80,
      background: '#1b252d',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& ul': {
        display: 'flex',
        paddingInlineStart: 0,
      },
    },
    menuItem: {
      textDecoration: 'none',
      color: 'white',
      margin: '0 20px',
      fontSize: 20,
      cursor: 'pointer',
      transition: 'transform .1s ease',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    menuFlag: {
      background:
        'linear-gradient(90deg, rgba(0,174,0,1) 33%, rgba(255,255,255,1) 33%, rgba(255,255,255,1) 66%, rgba(255,0,0,1) 66%, rgba(255,0,0,1) 100%)',
      height: 10,
      width: '100%',
    },
    activeMenuItem: {
      transform: 'scale(1.1)',
    },
  })
);

export const Header: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.topMenu}>
        <NavLink
          to='/'
          exact
          className={classes.menuItem}
          activeClassName={classes.activeMenuItem}
        >
          Home
        </NavLink>
        <NavLink
          to='/menu'
          exact
          className={classes.menuItem}
          activeClassName={classes.activeMenuItem}
        >
          Our Menu
        </NavLink>
      </div>
      <div className={classes.menuFlag}></div>

      <div className={classes.topWrap}>
        <div className={classes.topRight}>
          <div className={classes.logoWrapper}>
            <img src={logo} className={classes.topHeaderImage} />
            <h1 className={classes.logoText}>Little Nino&apos;s</h1>
          </div>
          <span className={classes.estText}>
            <span className={classes.italyFlag}></span>EST 2021
          </span>
          <div className={classes.topHeadingTextWrapper}>
            <p>
              Little Nino’s Cafe & Kitchen offers authentic Italian cuisine in
              the heart of Spital Tongues.
            </p>
            <Button
              size='large'
              variant='contained'
              classes={{ root: classes.buttonRoot }}
              startIcon={<RestaurantMenuIcon />}
              data-glf-cuid='fd3cddaa-823f-4a56-a896-5e9d4513963a'
              data-glf-ruid='31e232a9-0527-4d7f-94d2-324bc669aced'
            >
              Order Online
            </Button>
          </div>
        </div>
        <div className={classes.topLeft}></div>
      </div>
      <div className={classes.menuFlag}></div>
    </>
  );
};

export default Header;
